import { useEffect, useRef } from 'react';
const MERCURE_HUB = 'https://mercure.macommunelive.fr/.well-known/mercure';
/**
 * `token` est obligatoire pour un canal privé (tickets, groupes) : sans lui, le hub
 * n'envoie rien. L'EventSource du navigateur n'accepte pas d'en-têtes, le jeton
 * passe par le paramètre `authorization` que le hub Mercure lit aussi.
 */
export function useMercure(topic, onMessage, token) {
    const callbackRef = useRef(onMessage);
    callbackRef.current = onMessage;
    useEffect(() => {
        if (!topic)
            return;
        const url = new URL(MERCURE_HUB);
        url.searchParams.append('topic', topic);
        if (token)
            url.searchParams.append('authorization', token);
        const eventSource = new EventSource(url.toString());
        eventSource.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                callbackRef.current(data);
            }
            catch { }
        };
        return () => {
            eventSource.close();
        };
    }, [topic, token]);
}
